import { awaitTruthy, } from "@store/helpers";
import { dehydrate, hydrate, } from "@store/hydra";
import type { IBracketStore, } from "@store/types";
import { produce } from 'immer';
import type { StateCreator, } from "zustand";	
import type { Store } from '../useStore';
import { defaultAssetUSD, defaultBrktUSD, defaultDepWithBrktUSD, } from "./defaults";
import * as R from "./resolvers";
import type { IPlatformSlice, } from "./types";
// import { workers, } from "./workers";


export const createPlatformSlice: StateCreator<IBracketStore, [], [], IPlatformSlice> = ( set, get, ) => {



	const fetch = async () => {

		if(get().platform.fetching || get().platform.ready) {
			return;
		}

		set(produce<Store>(state => {
			state.platform.fetching = true;
		}));

		const { fetched, props, } = await hydrate("platform");	

		if(fetched) {
			set(produce<Store>(state => {
				Object.entries(props).forEach(([key, value]) => {
					if(key in state.platform) {
						// @ts-expect-error - fix this later.
						state.platform[key] = value;
					}
				});
				state.platform.ready = true;
			}));
		}


		const { useStore, } = await import("@store");
		await awaitTruthy(useStore, state => state.vaults.available.length);
		const { available: vaults, } = get().vaults;

		const [
			platformTvl,
			yourPlatformTvl,
			platform,
			colateralBalances,
			chains,
			brktTVL,
		] = await Promise.all([
			R.getPlatformTVL(vaults),
			R.getYourPlatformTVL_v2(vaults),
			R.getPlatform(),
			R.getTokenBalances(),
			R.getChains(),
			R.getBrktTVL(),
		]);

		set(produce<Store>(state => {
			state.platform.platform_tvl = platformTvl;
			state.platform.claimr_points = platform.claimr_points;
			state.platform.total_value = yourPlatformTvl;
			state.platform.ready = true;
			state.platform.fetching = false;
			state.platform.brkt_1d = platform.brkt_1d;
			state.platform.brkt_3d = platform.brkt_3d;
			state.platform.brkt_7d = platform.brkt_7d;
			state.platform.brkt_14d = platform.brkt_14d;
			state.platform.brkt_21d = platform.brkt_21d;
			state.platform.brkt_28d = platform.brkt_28d;
			state.platform.brkt_tvl = brktTVL;
			state.platform.colateralBalances = colateralBalances;
			state.platform.chains = chains;
		}));

		start_poll();

		set(produce<Store>(state => {
			state.platform.ready = true;
			state.platform.fetching = false;
		}));

		// const result = await workers.test({ message: "Worker Test" });
		// console.log("RESULT:", result);
		await dehydrate("platform", get().platform);

	}

	const reset = () => {
		throw new Error("store:platform::reset:: not implemented");
	}

	const resetAsync = async () => {
		return reset();
	}

	const start_poll = () => {

		if(_listener) {
			clear_poll();
		}

		_listener = setInterval(async () => {

			const { useStore, } = await import("@store");
			await awaitTruthy(useStore, state => state.vaults.ready);
			const { available: vaults, } = get().vaults;

			const [
				platform_tvl,
				your_platform_tvl,
			] = await Promise.all([
				R.getPlatformTVL(vaults),
				R.getYourPlatformTVL_v2(vaults),
			]);

			if(platform_tvl !== get().platform.platform_tvl) {
				set(produce<Store>(state => {
					state.platform.platform_tvl = platform_tvl;
				}));
			}

			if(your_platform_tvl !== get().platform.total_value) {
				set(produce<Store>(state => {
					state.platform.total_value = your_platform_tvl;
				}));
			}

		}, 10000);


	};


	const clear_poll = () => {
		if(_listener) {
			clearInterval(_listener);
		}
	};


	let _listener: NodeJS.Timeout | null = null;

	// place at the bottom of the call stack.
	setTimeout(_ => {
		// workers.initialize();
		fetch();
	}, 0);


	return {
		ready: false,
		fetching: false,
		claimr_points: -1,
		colateralBalances: [],
		chains: {},
		platform_tvl: defaultBrktUSD(),
		total_value: defaultBrktUSD(),
		brkt_1d: defaultDepWithBrktUSD(),
		brkt_3d:  defaultDepWithBrktUSD(),
		brkt_7d:  defaultDepWithBrktUSD(),
		brkt_14d:  defaultDepWithBrktUSD(),
		brkt_21d: defaultDepWithBrktUSD(),
		brkt_28d: defaultDepWithBrktUSD(),
		brkt_tvl: defaultAssetUSD(),
		fetch,
		reset,
		resetAsync,
		cleanup: clear_poll,
	};

};
